module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-profile-paul.97952bb.png";